export enum ButtonType {
  Primary = "primary",
  Default = "default",
  Ghost = "ghost",
};